const reports = [
	'0739CB05-F267-4AB2-B002-81D4A1DBFE1F',
	'08545134-8A9C-48AC-852D-D6AC9BE4F4EF',
	'1BC38FC5-1545-4852-A854-AA0DC9F6443D',
	'2BC4318E-B73A-4B63-B1CE-9827D4F4634A',
	'324EDDFD-D64E-44FF-A354-8719BB3ED6F0',
	'333DDF93-0A79-4754-9CC2-66B27EA08D14',
	'35E00167-833E-46B1-83DD-38471DBA5D23',
	'36B832A6-D029-4DF9-8543-0D5582217F9D',
	'3C82A5C6-4F02-4BF6-B046-BD382D06BB8B',
	'3DEC7A1F-BC9B-479C-A8AD-9639C3F5DFFF',
	'4725CCC9-7D54-4795-9F1D-022A56BD6087',
	'47FF1157-BF7E-45F1-8DA8-E65408206D60',
	'5277075A-2566-4589-B7D0-AECDCF1F47F6',
	'54E47CB0-6E8E-43FB-AE12-F1C6F9FE2CDD',
	'6036CF43-8FEB-4044-A7CB-E6D330FAEAB0',
	'613D7F60-60D0-4618-A380-26D69C8A213B',
	'65C36196-33AD-4B84-B1D0-A4D83E165E55',
	'661AB487-13D4-448D-87D2-7C2B15C9845F',
	'680F7EBF-1B96-4448-956B-70991E38492B',
	'68E41CA0-2199-41CA-BCD6-472246DBBFFD',
	'6C4AB052-C473-4D07-832E-792615311A03',
	'6F766E42-42A6-4114-B0B0-A940EBAA18B1',
	'7164B78C-BF86-4E64-ACAE-F7EF2BF287ED',
	'7A70C56A-792A-4095-89BE-BE4EF33E5529',
	'8189F33E-8689-46A5-AF48-B035C7B30B2E',
	'878CED19-0E7E-4DE4-8D3A-24D82D32BA12',
	'8D3D6710-37D2-4209-9113-C1BA66FEDF65',
	'8EACF5EC-3C6F-4526-AB6D-2F55DA7E1C7A',
	'9EC7C884-C153-492C-A05D-F5931026A5D5',
	'A20F9F93-16FF-45AE-AE22-03D838717CC4',
	'AD9397BD-6815-4D40-99B5-6CF991DD2B87',
	'AE99CB1E-1AC1-47BB-93A3-C69C3102E17F',
	'B4107F9B-DE56-4778-BB30-9399E3E47ACB',
	'B48F0707-EB93-43FB-AE9E-F8F7FD60F9D1',
	'B66CB123-4D95-4542-9D56-EA5495522BB5',
	'B78A5257-6C45-4CAB-A98B-53534A684B06',
	'B840FE7A-D464-43BF-9AEB-8028607CF4D2',
	'B93ACCFA-1495-49EB-A24F-F82EF2A9DD14',
	'BECCF24D-DA3A-4B30-9C42-1B6D1E1C7D2A',
	'BF4DBCEC-4392-4E11-A5CA-90B1B39F1E26',
	'C3EE7CD8-81BA-43F0-A70A-5BDDFA510C0E',
	'C5954FC6-CBBF-49D7-BEEC-CE1BAB549D5B',
	'C8142E8B-B8CF-408C-A067-7509CCB8075E',
	'CE88AA60-5184-4FE8-88AA-E64E6762B2A9',
	'DF395D10-A0E4-43F3-9225-3B802EB57740',
	'E4F852C7-F9C8-48D9-9679-A60619DDEAB8',
	'E78D4B97-DC69-4536-930E-68D0DA3EFDDE',
	'E973FAE9-EBC2-41CE-BBD7-53B67C13B88D',
	'EF83CD30-6A69-434F-9971-077EE03F38F6',
	'F74E3EED-A39E-406E-867D-0AE777B76D00',
	'FB9C1927-BA58-4DE4-BDFC-6E01ADEFA48F',
];

export const load = (app) => {
	reports.map((report) => {
		app.directive(`report${btoa(report)
			.toLowerCase()}`, require(`./${report}/index.js`).default);
	});
};




// WEBPACK FOOTER //
// ./src/js/directives/report/reports/index.js